import { useCallback } from "react";
import { useSaveProductMutation } from "../mutations/useSaveProduct.mutation";
import { ProductInterface } from "../../../interfaces/productInterface";

export const useSaveProduct = () => {
  const saveMutation = useSaveProductMutation();

  const handleSave = useCallback(
    (values: ProductInterface) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
